<template>
  <Widget class="risk-widget fill-height">
    <v-card
      style="border-radius: 6px"
      flat
      @click="
        statsStore.selectedRiskCategory =
          props.riskIndicatorsGroup.riskCategory;
        router.push(RouterPath.DetailedRiskCategory);
      "
      class="fill-height"
    >
      <v-card-title
        class="text-left d-flex mb-4 widget-title widget-color"
        :is="props.riskIndicatorsGroup.riskCategory"
      >
        <AppkitIcon
          class="pt-1 mr-2"
          :icon="setIcon(props.riskIndicatorsGroup)"
          size="large"
        >
        </AppkitIcon>
        {{
          riskCategoryToDescriptionText(props.riskIndicatorsGroup.riskCategory)
        }}
      </v-card-title>
      <v-card-text>
        <p class="text-right">
          Out of {{ statsStore.stats.supplyChainAnswerStats.noBusinessPartners + statsStore.stats.supplyChainAnswerStats.noSuppliers }}
        </p>
        <div v-if="props.riskIndicatorsGroup.top5Countries.length > 0">
          <p class="d-flex pt-2">
            <span class="text-left mr-1">Country risk</span>
            <v-spacer></v-spacer>
            <span class="text-right">{{
              props.riskIndicatorsGroup.top5Countries
                .map((c) => countryIndexWithChineseRegions[c])
                .join(", ")
            }}</span>
          </p>
          <v-divider></v-divider>
        </div>
        <div v-for="indicator in props.riskIndicatorsGroup.indicators">
          <v-row v-if="showIndicatorType(indicator.indicatorType, props.riskIndicatorsGroup.riskCategory)" no-gutters>
            <v-col cols="9" class="pt-1">
              <p class="text-left">{{ indicatorTypeToDescriptionText(indicator.indicatorType) }}</p>
            </v-col>
            <v-col>
              <p class="text-right">{{ indicator.suppliersWithFlagsCount }} ({{
                calculatePercentage(indicator.suppliersWithFlagsCount)
              }}%)</p>
            </v-col>
            <v-divider></v-divider>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </Widget>
</template>

<script setup lang="ts">
import Widget from "@/views/dashboard-view/Widget.vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { IndicatorType, indicatorTypeToDescriptionText } from "@/models/enum/indicatorType";
import { useStatsStore } from "@/stores/statsStore";
import {
  RiskCategory,
  riskCategoryToDescriptionText,
} from "@/models/enum/riskCategory";
import type RiskIndicatorsGroup from "@/models/risk-widgets/riskIndicatorsGroup";
import { countryIndexWithChineseRegions } from "@/modules/countries";
import { RouterPath } from "@/models/enum/routerPath";
import router from "@/router";
import { getIndicatorTypesForRiskCategory } from "@/models/indicatorTypesForRiskCategory";

function showIndicatorType(indicatorType: IndicatorType, riskCategory: RiskCategory) {
  return getIndicatorTypesForRiskCategory(riskCategory).includes(indicatorType);
}

const props = defineProps<{
  riskIndicatorsGroup: RiskIndicatorsGroup;
}>();

const statsStore = useStatsStore();

function setIcon(category: RiskIndicatorsGroup): string {
  switch (category.riskCategory) {
    case RiskCategory.LabourAndHumanRight:
      return "icon-family-outline";
    case RiskCategory.HealthAndSafety:
      return "icon-governance-outline";
    case RiskCategory.Environment:
      return "icon-growth-outline";
    case RiskCategory.BusinessIntegrity:
      return "icon-venn-abc-outline";
    case RiskCategory.SupplierManagement:
      return "icon-manufacturer-outline";
    default:
      return "icon-circle-more-outline";
  }
}

function calculatePercentage(flags: number) {
  return Math.round(
    (flags * 100) / ( statsStore.stats.supplyChainAnswerStats.noBusinessPartners + statsStore.stats.supplyChainAnswerStats.noSuppliers )
  );
}
</script>

<style scoped lang="scss">
.risk-widget {
  p {
    color: var(--dark-grey);
    font-size: 15px;
  }
}
</style>